module.exports = __webpack_public_path__ + "img/chat-wiki-entry.0b6862af.png";